'use strict';

var RecommendationHostPanelDirective = function RecommendationHostPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/recommendation-host-panel.html'),
    scope: {
      screenState: '=',
      dataDimension: '=dimension'
    }
  };
};
RecommendationHostPanelDirective.$inject = [];
module.exports = RecommendationHostPanelDirective;